import { render, staticRenderFns } from "./see_remark.vue?vue&type=template&id=4895fa9e&scoped=true&"
import script from "./see_remark.vue?vue&type=script&lang=js&"
export * from "./see_remark.vue?vue&type=script&lang=js&"
import style0 from "./see_remark.vue?vue&type=style&index=0&id=4895fa9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4895fa9e",
  null
  
)

export default component.exports